<div id="non-dues-aging" style="height: calc(100%)">
  <wl-card>
    <div class="mct-flex mct-col mct-justify-between mct-items-stretch"   style="height: calc(100%)">
      <div style="padding-bottom: 10px; border-bottom: 1px solid #999" class="f-wb">
        {{ 'dashboard.revenue.non-dues-aging' | translate | titlecase }}
      </div>
      <p-chart #agingChart type="bar" [data]="chartData" [options]="chartOptions" [height]="136" [width]="136"></p-chart>
      <div>
        <div class="f-wb mb-6">{{ 'dashboard.revenue.non-dues-total' | translate | titlecase }}</div>
        <div>{{ this.agingTotals?.AmountDue | currency }}</div>
      </div>
    </div>
  </wl-card>
</div>
